import { useUserOwnedNft } from "@/app/nft/hooks/use-user-owned-nft"
import { ListingDialogReatom } from "@/app/nft/order/listing-dialog/listing-dialog.reatom"
import { BuyButtonReatom as BuyButton } from "@/app/nft/order/widget/actions/buy.reatom"
import { CancelButtonReatom as CancelButton } from "@/app/nft/order/widget/actions/cancel.reatom"
import { shouldShowBuyCta } from "@/app/nft/should-show-buy-cta"
import { SDKNFTScope } from "@/app/sdk/anaconda-sdk-scope"
import { isExternalListing } from "@anaconda/core/nft/listing-source"
import type { NftSearchItem } from "@anaconda/core/nft/search/types"
import { Trans } from "@lingui/react/macro"
import { reatomComponent } from "@reatom/react"
import { ScopeProvider } from "bunshi/react"

export const Action = reatomComponent(({ nft }: { nft: NftSearchItem }) => {
  const { userOwnedNft } = useUserOwnedNft(nft)

  if (!userOwnedNft) {
    if (!shouldShowBuyCta(nft, userOwnedNft)) return <span>—</span>

    return (
      <ScopeProvider scope={SDKNFTScope} value={nft}>
        <BuyButton nft={nft}>
          <Trans>Buy</Trans>
        </BuyButton>
      </ScopeProvider>
    )
  }

  return (
    <ScopeProvider scope={SDKNFTScope} value={nft}>
      {!nft.price ? (
        <ListingDialogReatom nft={nft} />
      ) : isExternalListing(nft.listingSource) ? (
        <span>—</span>
      ) : (
        <CancelButton nft={nft} />
      )}
    </ScopeProvider>
  )
}, "Action")
